// src/utils/newstore.ts
interface NewStoreFormData {
  storeId?: string;
  associateId?: string;
  storeInfo?: {
    storeId: string;
    label: string;
  };
  // [key: string]: string | undefined;
}

interface ExternalIdentity {
  identityProvider: string;
  identity: string;
}

interface NewStoreWindow {
  auth?: {
    accessToken: string;
  };
  contextProps?: {
    formData: NewStoreFormData;
  };
  externalIdentity?: string;
  externalIdentities?: ExternalIdentity[];
}
declare global {
  interface Window {
    NEWSTORE?: NewStoreWindow;
  }
}

export function getNewStoreData(): {
  accessToken: string | null;
  storeId: string | null;
  storeLabel: string | null;
  associateId: string | null;
  externalId: string | null;
} {
  if (!window.NEWSTORE) {
    if (window.location.hash) {
      try {
        window.NEWSTORE = JSON.parse(
          atob(window.location.hash.replace(/^#/, ''))
        );
      } catch {
        window.NEWSTORE = {};
      }
    } else {
      window.NEWSTORE = {
        auth: { accessToken: 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICI1aDhrck43Y3REVGlZaVRTR2pucHBOUmRvVVlhNUIxOXNkTkpUV0hBS0FBIn0.eyJleHAiOjE3NjIwNzcyMDAsImlhdCI6MTc2MjA3MzYwMCwianRpIjoiZTMyZDU4OWUtMjRlOS00MzYyLThlYzctOTU4OWY1YjhjMmViIiwiaXNzIjoiaHR0cHM6Ly9pZC5wLm5ld3N0b3JlLm5ldC9hdXRoL3JlYWxtcy9qYW1lc2F2ZXJ5LXN0YWdpbmciLCJhdWQiOiJqYW1lc2F2ZXJ5LXN0YWdpbmciLCJzdWIiOiI0YjM1MmYwMC0yOWFkLTRlZmUtYTQ2MC1iYTMwOTc1MDc1OWEiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJjM2Q5ZDEyNS0xYWI3LTQzOTUtYjUyMi0wZDM4MjI0NjU3NWIiLCJzY29wZSI6ImNhdGFsb2c6cHJvZHVjdC1leHBvcnQ6cmVhZCBuZXdzdG9yZTpjb25maWd1cmF0aW9uOnJlYWQgY3VzdG9tZXI6cHJvZmlsZTpyZWFkIHNoaXBtZW50czpyZWFkIG5ld3N0b3JlOmNvbmZpZ3VyYXRpb246d3JpdGUgY2F0YWxvZzpwcmljZWJvb2stZXhwb3J0OnJlYWQgY3VzdG9tZXI6cHJvZmlsZTp3cml0ZSBjYXRhbG9nOmltcG9ydC1zY2hlbWFzOndyaXRlIHNoaXBtZW50czp3cml0ZSBjYXRhbG9nOmltcG9ydC1zY2hlbWFzOnJlYWQiLCJjbGllbnRIb3N0IjoiNTQuODYuNTAuMTM5IiwiaHR0cDovL25ld3N0b3JlL25ld3N0b3JlX2lkIjoiNGIzNTJmMDAtMjlhZC00ZWZlLWE0NjAtYmEzMDk3NTA3NTlhIiwiY2xpZW50QWRkcmVzcyI6IjU0Ljg2LjUwLjEzOSIsImNsaWVudF9pZCI6ImMzZDlkMTI1LTFhYjctNDM5NS1iNTIyLTBkMzgyMjQ2NTc1YiIsImh0dHA6Ly9uZXdzdG9yZS90ZW5hbnQiOiJqYW1lc2F2ZXJ5LXN0YWdpbmcifQ.ulARhk5T5UAx_sQyA8Aoa38dG6oVVuHP9gxn4QmyDaUsARQC2r8gsUVuGVg-pmgaBc7-n2gKh2pSK8u1TXJnCCF-SPw-np2FCRiXnNUN6Dr1jhtZFUVtCS2g_PCXi-0Yl5Vj8DLBMBhm3tnSylULcFCaK5PBAfVl7J5Djmt_63KIhtJRkUqf8M89ZaECmLOfnjcixWyeaeCPCnRUEtKol9cL6sGmEz0bAGVuNY5VTwRMxMJnhnfcWSX-DRq6FdkLyGSHzwuvee0O2f272RjLCS6-Scv6Hvw6B8FMFfoP6LQnctoyBwspBBiyWusII7KYo-X4yY4kY-2pdPfeAiwc4A' },
        contextProps: {
          formData: { storeId: '053', associateId: 'abc_123', storeInfo: { storeId: '053', label: '053 - James Avery Plaza' } },
        },
        externalIdentities: [{
          identityProvider: "nsi-integrations",
          identity: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIzMzJlMzEzMy0zMTUwLTRiZTktYjBlZC0xYzlmZTU5NzNiNmQiLCJpYXQiOjE3NTk4MzM0MDQsImV4cCI6MTc2MTYzMzQwNCwicm9sZXMiOlsiZW5ncmF2aW5nIiwiY29uc2VudCIsInNlcnZpY2UtaXNzIl19.bvgGl3SUbbCwjSC8OAuvK3x__OMbiker1r1zPzf73uc'
        }
        ]
      };
    }
  }

  const accessToken = window?.NEWSTORE?.auth?.accessToken ?? null;
  const storeId = window?.NEWSTORE?.contextProps?.formData.storeId ?? null;
  const storeLabel = window?.NEWSTORE?.contextProps?.formData.storeInfo?.label ?? null;
  const associateId =
    window?.NEWSTORE?.contextProps?.formData.associateId ?? null;
  const nsiIntegration = window?.NEWSTORE?.externalIdentities?.find(e => e.identityProvider === "nsi-integrations");
  const externalId = nsiIntegration?.identity ?? null;
  return { accessToken, storeId, storeLabel, associateId, externalId };
}
